import { useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton } from '@chakra-ui/react';
import { MdVisibility } from 'react-icons/md';

import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import { useGetConsents } from '../queries';
import { mapConsentRow } from '../utils';

const ConsentsTable = ({ profileId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const gridRef = useRef(null);

    const { data: rawConsents, isLoading, refetch } = useGetConsents(profileId);

    const consents = useMemo(
        () => rawConsents?.map(mapConsentRow) ?? [],
        [rawConsents],
    );

    const columnDefs = useMemo(
        () => [
            { headerName: 'Tenant ID', field: 'tenantID' },
            { headerName: 'Status', field: 'status' },
            { headerName: 'Company Name', field: 'defaultContact.companyName' },
            {
                headerName: 'Consented Countries',
                field: 'consentedCountriesString',
            },
            { headerName: 'Contact Name', field: 'defaultContact.fullName' },
            { headerName: 'Email', field: 'defaultContact.email' },
            { headerName: 'Phone', field: 'defaultContact.phoneNumber' },
            {
                headerName: 'Action',
                field: 'action',
                maxWidth: 100,
                cellRenderer: (params) => (
                    <IconButton
                        aria-label="View consent"
                        icon={<MdVisibility />}
                        variant="ghost"
                        color="inherit"
                        size="sm"
                        onClick={() =>
                            navigate(
                                `/operator-connect-profiles/${profileId}/consents/${params.data.id}${location.search}`,
                            )
                        }
                    />
                ),
                filter: false,
                sortable: false,
            },
        ],
        [navigate, profileId, location.search],
    );

    const tableDataWithColumns = useMemo(
        () => ({ columns: columnDefs, data: consents }),
        [consents, columnDefs],
    );

    return (
        <AGGridMain
            gridRef={gridRef}
            tableData={tableDataWithColumns}
            titleName="Consents"
            isLoading={isLoading}
            refetch={refetch}
            useFixedHeight={false}
            domLayout={consents?.length > 0 ? 'autoHeight' : 'normal'}
            customHeight={consents?.length === 0 ? '140px' : 'auto'}
        />
    );
};

export default ConsentsTable;
